export default __webpack_public_path__ + "static/media/Imagem Main Content-1.97a3cb1a.png";